// extracted by mini-css-extract-plugin
export var measureBox = "_42-0";